import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `http://wiiohv.cn/${item.href}` : undefined,
    })),
  };

  return (
    <>
      <nav aria-label="面包屑导航" className="bg-background-100 py-3">
        <div className="px-4 md:px-6 lg:px-10">
          <ol className="flex items-center gap-2 text-sm text-foreground-500">
            {items.map((item, index) => (
              <li key={index} className="flex items-center gap-2">
                {index > 0 && (
                  <span className="text-foreground-300">/</span>
                )}
                {item.href ? (
                  <Link to={item.href} className="hover:text-accent-500 transition-colors">
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-foreground-700 font-medium">{item.label}</span>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}